import { hmsConstants } from "../../_constants";

const initialState = {};

export const get_generated_hms_client_token_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_SUCCESS:
      return {
        type: "alert-success",
        hmsGeneratedClientTokenData: action.payload,
      };
    case hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_hms_room_details_reducer = (state = initialState, action) => {
  switch (action.type) {
    case hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        hmsRoomDetailData: action.payload,
      };
    case hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const create_hms_room_question_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hmsConstants.CREATE_HMS_ROOM_QUESTION_ACTION_REQUEST:
    case hmsConstants.UPDATE_HMS_ROOM_QUESTION_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hmsConstants.CREATE_HMS_ROOM_QUESTION_ACTION_SUCCESS:
    case hmsConstants.UPDATE_HMS_ROOM_QUESTION_ACTION_SUCCESS:
      return {
        type: "alert-success",
        hmsRoomUpdatedQuestionData: action.payload,
      };
    case hmsConstants.CREATE_HMS_ROOM_QUESTION_ACTION_FAILURE:
    case hmsConstants.UPDATE_HMS_ROOM_QUESTION_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_hms_room_questions_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hmsConstants.GET_HMS_ROOM_QUESTION_ACTION_SUCCESS:
      return {
        type: "alert-success",
        hmsRoomQuestionsData: action.payload,
      };
    case hmsConstants.GET_HMS_ROOM_QUESTION_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_hms_room_question_rating_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hmsConstants.GET_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST:
    case hmsConstants.UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST:
    case hmsConstants.CREATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hmsConstants.GET_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS:
    case hmsConstants.UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS:
    case hmsConstants.CREATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS:
      return {
        type: "alert-success",
        hmsRoomQuestionRatingData: action.payload,
      };
    case hmsConstants.GET_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE:
    case hmsConstants.UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE:
    case hmsConstants.CREATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
